import React from 'react';
import classNames from 'classnames';

import './ModalSimplePanel.scss';

export interface ModalSimplePanelProps {
  children: React.ReactNode;
  // Show modal title + close button
  showHead?: boolean;
  // title shown in modal
  title?: string;
  sizeAuto?: boolean;
  noPadding?: boolean;
  // run function when clicked on X of the modal
  closeCallback?(): void;
}

const ModalSimplePanel = ({ children, showHead = false, title, sizeAuto, noPadding, closeCallback }: ModalSimplePanelProps) => {
  return (
    <div styleName={classNames('modal-panel', { 'modal-panel--size-auto': sizeAuto, 'modal-panel--no-padding': noPadding })}>
      { showHead &&
        <div styleName="modal-panel__head">
          <div styleName="modal-panel__head-text">{title}</div>
          <div styleName="modal-panel__close" onClick={closeCallback}>
            <span className="dashicon dashicon-close" />
          </div>
        </div>
      }
      <div styleName="modal-panel__content-wrapper">
        <div styleName="modal-panel__content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalSimplePanel;
